export const colors = [
  [0, "#f11d28"],
  [0.166667, "#fd3a2d"],
  [0.333333, "#fe612c"],
  [0.5, "#ff922c"],
  [0.666667, "#ffc42c"],
  [0.833333, "#ccff2c"],
  [1, "#2cff32"],
];

export const colorsPulse = (blue_threshold = 100, green_threshold = 70, yellow_threshold = 50) => {
  const colors = [
    [yellow_threshold / 100, RED],
    [green_threshold / 100, YELLOW],
    [blue_threshold / 100, GREEN],
  ];
  if (blue_threshold < 100) {
    colors.push([1, BLUE]);
  }
  return colors;
};

export const colorsSoil = [
  [0, "#f11d28"],
  [0.1, "#fd3a2d"],
  [0.2, "#fe612c"],
  [0.3, "#ff922c"],
  [0.4, "#ffa62c"],
  [0.5, "#93ff2c"],
  [0.6, "#59ff43"],
  [0.7, "#2cff32"],
  [0.8, "#0099FF"],
  [0.9, "#0055FF"],
  [1, "#0000FF"],
];

export const colorsSoilMoisture = (pwp, max_nf, max_f) => {
  pwp = pwp ? pwp / 100 : 0.1;
  max_nf = max_nf ? max_nf / 100 : 0.25;
  max_f = max_f ? max_f / 100 : 0.45;
  const first = pwp;
  const fourth = pwp + ((max_nf / 2) * (max_nf - pwp)) / max_nf;
  const seventh = max_nf;
  const nineth = max_f;

  return [
    [0, RED],
    [first, RED],
    [fourth, YELLOW],
    [seventh, GREEN],
    [nineth, BLUE],
    [1, DARKBLUE],
  ];
};

export const colorsSoilWaterTension = (soil) => {
  const yellow_threshold = soil
    ? soil.yellow_threshold_swt
      ? -Math.pow(10, soil.yellow_threshold_swt) / 10
      : -120
    : -120;
  const green_threshold = soil
    ? soil.green_threshold_swt
      ? -Math.pow(10, soil.green_threshold_swt) / 10
      : -60
    : -60;
  const blue_threshold = soil
    ? soil.blue_threshold_swt
      ? -Math.pow(10, soil.blue_threshold_swt) / 10
      : -6
    : -6;

  return [
    [yellow_threshold, RED],
    [green_threshold, YELLOW],
    [blue_threshold, GREEN],
    [0, BLUE],
  ];
};

export const colorsBiodiversity = [
  [0, "#f7ff2c"],
  [0.1, "#faff2c"],
  [0.2, "#f9ff2c"],
  [0.3, "#f8ff2c"],
  [0.4, "#ecff2c"],
  [0.5, "#ccff2c"],
  [0.6, "#a9ff2c"],
  [0.7, "#93ff2c"],
  [0.8, "#93ff2c"],
  [0.9, "#59ff43"],
  [1, "#2cff32"],
];

export const colorsDendrometer = () => {
  // For drought_days (2-week window):
  // 0 days: GREEN
  // >= 1 day: YELLOW
  // >= 7 days: RED
  return [
    [1 / 14, GREEN],
    [7 / 14, YELLOW],
    [1, RED],
  ];
};
export const findClosest = function (x, arr) {
  // NOTE: it acually searches for the idx which is closest but higher
  const indexArr = arr.map(function (k) {
    return Math.abs(k[0] - x);
  });
  const min = Math.min.apply(Math, indexArr);
  // return arr[indexArr.indexOf(min)];
  let idx = indexArr.indexOf(min);
  if (arr[idx][0] < x && idx < arr.length - 1) {
    idx = idx + 1;
  }
  const idx_value = arr[idx];
  return idx_value;
};

export function shadeColor(color, percent) {
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  R = Math.round(R);
  G = Math.round(G);
  B = Math.round(B);

  var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
  var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
  var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
}

export const WHITE = "#EAEAEA";
export const GREY = "#808080";
export const GREEN = "#A3CF6C";
export const DARKGREEN = "#006400";
export const YELLOW = "#FFBA4A";
export const RED = "#EF5C5C";
export const BLUE = "#00a3e8";
export const DARKBLUE = "#03273B";
